import React from 'react'
import { Redirect, Route, RouteProps } from 'react-router-dom'

import { isAuthenticated } from '~/firebase'
import { SIGN_IN } from '~/pages/routes'


export default function PrivateRoute({...props}: RouteProps) {
  return isAuthenticated()
    ? <Route {...props}/>
    : (
      <Redirect
        from={props.path}
        to={{pathname: SIGN_IN, state: {from: props.path}}}
      />
    )
}



// WEBPACK FOOTER //
// ./src/HOC/PrivateRoute.tsx